import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const MobileTicket: React.FC<Props> = ({ className, width = '24', height = '24' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className}>
    <path d="M11 16.5a.75.75 0 000 1.5h2a.75.75 0 000-1.5h-2z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.09 2A2.1 2.1 0 005 4.15v15.72c0 1.15.9 2.13 2.08 2.13h9.82c1.17 0 2.08-.98 2.08-2.13V4.14a2.1 2.1 0 00-2.08-2.13H7.09zM6.5 19.87V4.14c0-.38.28-.63.58-.63h9.82c.3 0 .58.25.58.63v15.72c0 .38-.29.63-.58.63H7.09c-.3 0-.58-.25-.58-.63z"
    />
  </svg>
);

export default MobileTicket;
